import * as config from "../config.json";

let backendConfiguration = {
  host: "",
  protocol: "",
  port: -1,
};
if (process.env.NODE_ENV === "development") {
  backendConfiguration = { ...backendConfiguration, ...config.dev };
} else {
  // In production, derive from current location so docker-compose and deployments work without hardcoding host
  const loc = window.location;
  backendConfiguration.host = loc.host; // includes port if any
  backendConfiguration.protocol = loc.protocol.replace(":", "");
}

export function addressBuilder(
  path: string,
  parameters?: { key: string; val: string }[]
): URL {
  const baseURL: string = `${backendConfiguration.protocol}://${backendConfiguration.host}/backend/`;
  return new URL(`${baseURL}${path}`);
}
